import React from 'react';

import PurifiedText from '../../PurifiedText';

/**
 * Types
 */

interface Props {
  answer: string;
}

/**
 * Component
 */

export default function FAQItemContent({ answer }: Props) {
  return (
    <PurifiedText
      className="text-site-neutrals-500 site-paragraph-m pb-6 [&_a]:underline [&_ul]:list-inside [&_ul]:list-disc"
      addAttr={['target']}
    >
      {answer}
    </PurifiedText>
  );
}
